export function lockDocumentResizeCursor(
  cursor: 'col-resize' | 'row-resize' = 'col-resize'
): () => void {
  const { body } = document
  const previousCursor = body.style.cursor
  const previousUserSelect = body.style.userSelect
  body.style.cursor = cursor
  body.style.userSelect = 'none'
  return () => {
    body.style.cursor = previousCursor
    body.style.userSelect = previousUserSelect
  }
}
